<template>
  <div class="personAttestation" :class="tohidden">
    <div class="uploadPage_toptitle">
      <div class="uploadPage_toptitlebox">
        <van-icon class="uploadPage_back" name="arrow-left" @click="backClick" />
        <div class="uploadPage_title">个人认证</div>
        <van-icon name="close" v-show="
          $store.state.system == 'android' &&
          applets != 'xcx' &&
          !$store.state.isXcx &&
          $store.state.isInGame
        " @click="closeCommunity" />
        <p class="personAttestation_tit">
          适合社区攻略大神、活跃达人等类型创作者申请
        </p>
      </div>
    </div>
    <div class="personAttestation_content">
      <!-- 1申请 -->
      <div class="personAttestation_part1" v-if="positionField == 'part1'">
        <div class="personAttestation_content_top">
          <h3>申请条件</h3>
          <div class="personAttestation_item" :class="condition.snsLevel ? 'on' : ''" v-if="false">
            <p>社区等级≥3</p>
            <span v-if="!condition.snsLevel">去完成</span>
            <span v-if="condition.snsLevel">已达标</span>
          </div>
          <div class="personAttestation_item" :class="condition.topics ? 'on' : ''">
            <p>近30天發布帖子数量≥4</p>
            <span v-if="!condition.topics" @click="toUpload">未达标</span>
            <span v-if="condition.topics">已达标</span>
          </div>
          <div class="personAttestation_item" :class="condition.fans ? 'on' : ''">
            <p>粉丝数量≥10</p>
            <span v-if="!condition.fans">未达标</span>
            <span v-if="condition.fans">已达标</span>
          </div>
          <span class="toApply" @click="toApply">立即申请</span>
        </div>
        <span class="personAttestation_content_mid"></span>
        <div class="personAttestation_content_bot">
          <h3>认证特权</h3>
          <div class="personAttestation_content_bot_wrap">
            <div class="personAttestation_content_bot_item">
              <h3>认证标识</h3>
              <p>彰显独特身份</p>
              <img src="@/assets/img/icon1.png" alt="" />
            </div>
            <div class="personAttestation_content_bot_item right">
              <h3>专属礼包</h3>
              <p>首次认证奖励</p>
              <img src="@/assets/img/icon2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 2提交 -->
      <div class="personAttestation_part2" v-if="positionField == 'part2'">
        <div class="personAttestation_part2_content">
          <h3>认证信息</h3>
          <!-- <input
            type="text"
            class="attestation_title"
            placeholder="请填写认证领域及头衔，比如：攻略作者"
          /> -->
          <van-dropdown-menu class="attestation_title">
            <van-dropdown-item v-model="attestation_title_value" :options="option1" @open="openMenu" />
          </van-dropdown-menu>
          <h3>申请理由</h3>
          <textarea name="reason" class="applyReason" id="applyReason" cols="30" rows="10" v-model="textcon"
            placeholder="请填写申请理由" maxlength="500"></textarea>
          <span class="toSubmit" @click="toSubmit">提交</span>
        </div>
      </div>
      <!-- 3审核 -->
      <div class="personAttestation_part3" v-if="positionField == 'part3'">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon class="uploadPage_back" name="arrow-left" @click="backClick" />
            <div class="uploadPage_title">个人认证</div>
          </div>
        </div>
        <div class="con">
          <img src="@/assets/img/icon3.png" alt="" />
          <p>审核中</p>
          <span>审核结果将在7个工作日内通过“消息通知”告知</span>
        </div>
      </div>
      <!-- 4已提交 -->
      <div class="personAttestation_part4" v-if="positionField == 'part4'">
        <div class="uploadPage_toptitle">
          <div class="uploadPage_toptitlebox">
            <van-icon class="uploadPage_back" name="arrow-left" @click="backClick" />
            <div class="uploadPage_title">个人认证</div>
          </div>
          <img class="userPic" :src="img" alt="" />
          <p class="userName">{{ attestationData.name }}</p>
          <div class="title_attestation">
            <p>
              <img v-if="$store.state.gameType == 1" src="@/assets/img/icon4.png" alt="" />
              <img v-if="$store.state.gameType == 2" src="@/assets/img/icon4.png" alt="" />
              <img v-if="$store.state.gameType == 3" src="@/assets/img/dqss/icon5_homepage.png" alt="" />
              个人认证：{{
                condition.authInfo
              }}
            </p>
          </div>
        </div>
        <div class="con">
          <div>
            <h3>维持认证需要</h3>
            <div class="con_txt">
              <p v-if="$store.state.gameType == 1"><img src="@/assets/img/icon7.png" alt="" />保持更新</p>
              <p v-if="$store.state.gameType == 2"><img src="@/assets/img/icon7.png" alt="" />保持更新</p>
              <p v-if="$store.state.gameType == 3"><img src="@/assets/img/dqss/icon7.png" alt="" />保持更新</p>
              <p v-if="$store.state.gameType == 1"><img src="@/assets/img/icon8.png" alt="" />内容优质</p>
              <p v-if="$store.state.gameType == 2"><img src="@/assets/img/icon8.png" alt="" />内容优质</p>
              <p v-if="$store.state.gameType == 3"><img src="@/assets/img/dqss/icon8.png" alt="" />内容优质</p>
            </div>
            <div class="btn_wrap">
              <span @click="cancelAttestation">取消认证</span>
              <span @click="changeAttestation">更换认证</span>
            </div>
          </div>
        </div>
      </div>
      <!-- rule -->
      <div class="attestationRuleWrap" v-if="toAttestationRuleWrapFlag">
        <div class="head">
          <van-icon class="uploadPage_back" name="arrow-left" @click="closeRule" />
          <div>常见问题</div>
          <span></span>
        </div>
        <div class="con">
          <div>
            <p>
              为了提升优质用户在社区中的标杆作用，同时也为了丰富社区文化氛围，增设个人认证体系，让用户可以获得更多曝光，更好地在人群中脱颖而出，以方便其他用户在寻找和关注感兴趣的内容或用户时降低筛选的成本，从而获得更多关注和认可！
            </p>
            <p></p>
            <p class="title">常见问题</p>
            <p class="title">1.什么是个人认证？</p>
            <p>
              个人认证是社区对优质创作者的认可与确认，认证信息为平台设置的相关身份。获得认证的用户会有对应的认证标识及认证信息，该认证会展示在用户个人主页、评论、帖子列表等多个页面。
            </p>
            <p>
              ①认证代表用户身份的真实性，或者阶段时间内因發布优质内容在社区获得认可，但认证不代表该认证用户發布的内容是完全正确的。
            </p>
            <p>
              ②个人加V认证包括：「攻略大神」、「活跃达人」、「分享达人」、「社交达人」，认证者可考量自己的情况，选择相应的认证方式进行认证，不恰当的类型选择有可能影响认证的通过率。
            </p>
            <p class="title">2.申请个人认证的条件有哪些？</p>
            <p>① 近30天發布帖子数量≥4</p>
            <p>② 粉丝数量≥10</p>
            <p class="title">3.认证周期所需时间以及认证进度查询？</p>
            <p>
              申请认证并提交认证相关信息后，会在7个工作日内进行反馈，可以留意社区消息提醒。
            </p>
            <p class="title">4.获得个人认证后要做什么？</p>
            <p>
              ①
              保持更新：持续产出优质内容，与粉丝保持互动，可以提升自己的影响力；
            </p>
            <p>② 内容优质：产出高质量内容，增加话题度，提高自己的粉丝数量。</p>
            <p class="title">5.同一用户是否可以获得多个认证信息呢？</p>
            <p>
              用户仅可申请「攻略大神」「活跃达人」「分享达人」「社交达人」这几种认证中的其中一种，不可获取多个身份认证信息的展示哦。
            </p>
            <p>
              认证者可考量自己的情况，择其一种进行申请。不恰当的选择有可能影响认证通过。
            </p>
            <p class="title">6.哪些情况将不予通过个人认证？</p>
            <p>
              为了确保所认证的账号信息属实，以及该账号为社区带来的影响。以下行为可能会导致审核不通过（包含但不局限）：
            </p>
            <p>①创作内容和申请认证类型不匹配；</p>
            <p>②优质内容数量质量不达标；</p>
            <p>③曾违反社区版规或曾发表过争议性内容；</p>
            <p>
              若有相关疑问，大家可以在社区点击“底部导航栏【我的】-【设置】-【建议与反馈】”反馈给我们。
            </p>
            <p class="title">7.若申请不通过是否可以重新申请？</p>
            <p>当然可以！</p>
            <p>申请不通过后，会收到社区的消息提示，你可以重新提交认证申请。</p>
            <p class="title">8.认证信息提交后可以修改吗？</p>
            <p>① 认证审核期间，是不支持修改的；</p>
            <p>
              ②
              认证通过后，支持更换认证信息，但更换认证信息会再次判断是否满足申请认证条件，提交后需要重新进行审核；
            </p>
            <p>
              所以在填写认证信息的过程中，要仔细进行考量再填写哦，尽量慎重更换认证信息。
            </p>
            <p class="title">
              9.更换认证身份信息后，会把我之前的认证信息取消掉吗？
            </p>
            <p>主要有两种情况：</p>
            <p>① 已有身份，选择更换认证信息，审核未通过；</p>
            <p>如果审核未通过的情况下，将会为你保留原有的认证信息；</p>
            <p>② 已有身份，选择更换认证信息，审核通过；</p>
            <p>
              如果审核通过的情况下，则会覆盖原有的认证信息，你的认证信息将以更换后的信息进行展示。
            </p>
            <p class="title">10.认证礼包如何发放？</p>
            <p>
              首次认证成功后（不包括多次认证或更换认证），礼包将发放到你当时申请认证的游戏角色下，可前往游戏邮箱内领取，礼包内容保密哦～
            </p>
            <p class="title">11.是否可以取消个人认证？</p>
            <p>
              认证通过后，支持取消个人认证，在取消后的15天内，将无法再进行认证申请，所以尽量慎重取消认证信息。
            </p>
            <p class="title">12.哪些情况将撤销个人认证？</p>
            <p>
              我们会定期复审个人认证作者，若您出现以下行为，社区可能会撤销您的个人认证。
            </p>
            <p>① 活跃度下降；</p>
            <p>② 内容质量下降；</p>
            <p>
              ③
              内容违规：用户头像、用户名、發布内容违反《紫龙游戏用户协议》《社区版规》。
            </p>
          </div>
        </div>
      </div>
      <p class="attestationRule" @click="toAttestationRuleWrap">常见问题</p>
    </div>
  </div>
</template>
<script>
import get from '../../../../api/get';
import qs from 'qs';
import * as _code from '../../../../utils/code';
import { Toast, Dialog } from 'vant';
export default {
  name: 'personAttestation',
  props: {
    name: {
      type: String,
      default: ''
    },
    attestationData: {}
  },
  components: {
    // [Dialog.Component.name]: Dialog.Component,
  },
  mounted() {
    console.log(this.$store.state.memberId);
    this.tohidden = 'on';
    this.getAuthCond();
    this.img = this.attestationData.img;
    console.log(this.attestationData);
  },
  data() {
    return {
      applets: window.user.weixcode ? "xcx" : "",
      nameText: this.name,
      img: '',
      toAttestationRuleWrapFlag: false,
      tohidden: 'on',
      positionField: 'part1',
      attestation_title_value: 0,
      textcon: '',
      option1: [
        { text: '请选择', value: 1 },
        { text: '认证头衔1', value: 1 },
        { text: '认证头衔2', value: 2 },
        { text: '认证头衔3', value: 3 }
      ],
      condition: {
        apply: false, //是否在认证审核
        snsLevel: false, //社区等级
        fans: false, //粉丝数量
        topics: false, //发帖数
        auth: false, //是否有认证
        authInfo: '', //认证头衔
        cancelDate: '' //取消认证时间
      },
      changeFlag: false //是否更换认证
    };
  },
  methods: {
    clearName() {
      this.nameText = '';
    },
    // 查询认证条件
    getAuthCond() {
      let _this = this;
      _this.getAuthTitles();
      get.authCond().then((res) => {
        this.condition.apply = res.data.data.apply;
        this.condition.snsLevel = res.data.data.snsLevel;
        this.condition.fans = res.data.data.fans;
        this.condition.topics = res.data.data.topics;
        this.condition.auth = res.data.data.auth;
        this.condition.authInfo = res.data.data.authInfo;
        this.condition.cancelDate = res.data.data.cancelDate;

        // this.condition.apply = true;
        // this.condition.auth = true;
        // this.condition.authInfo = '认证头衔111111';
        if (this.condition.apply) {
          this.positionField = 'part3';
        } else {
          if (this.condition.auth) {
            this.positionField = 'part4';
          }
        }
      });
    },
    // 查询认证头衔列表
    getAuthTitles() {
      get.authTitles().then((res) => {
        this.option1 = res.data.data;
        this.option1.forEach((n, i) => {
          n.value = i + 1;
          n.text = n.authTitle;
        });
        this.option1.unshift({ text: '请选择', value: 0 });
      });
    },
    openMenu() {
      return;
      this.option1.forEach((n, i) => {
        n.value = i + 1;
        n.text = n.authTitle;
        if (n.text == '请选择') {
          // this.option1.splice(n,1);
        }
      });
    },
    submitName() {
      if (this.nameText == '') {
        Toast('用户名不能为空');
        return;
      }
      let obj = {
        newNickname: this.nameText
      };
      get.nickname(qs.stringify(obj)).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          Toast('修改成功');
          this.$emit('cancelMethod');
        } else {
          if (data.code == 2002) {
          } else {
            this.errorMessage(data);
          }
        }
      });
    },
    getTime(time) {
      let d = new Date(time);
      let Y = d.getFullYear();
      let M = d.getMonth() + 1;
      let D = d.getDate();

      let YMD = this.addZero([Y, M, D], '-');
      // return Y+'年'+M+'月'+D+'日';
      return YMD;
    },
    addZero(dateArr, char) {
      return dateArr.map((v) => (v < 10 ? '0' + v : v)).join(char);
    },
    toApply() {
      // console.log(this.getTime((this.condition.cancelDate+60*60*24*15*1000)));
      let time = new Date().getTime();
      let cancelTime = this.condition.cancelDate;
      let applyTime = this.condition.cancelDate + 60 * 60 * 24 * 15 * 1000;
      if (time < applyTime) {
        Toast(
          '取消认证未满15天，请于' + this.getTime(applyTime) + '后再次申请'
        );
        return;
      } else {
        if (this.condition.topics && this.condition.fans) {
          //达成条件
          this.positionField = 'part2';
        } else {
          Toast('未达成条件');
        }
      }
    },
    toSubmit() {
      // console.log(this.attestation_title_value);
      // console.log(this.textcon);
      // console.log(this.option1[this.attestation_title_value-1].text);
      let _this = this;
      if (this.attestation_title_value == 0) {
        Toast('请选择认证信息');
        return;
      }
      let applyData = {
        appKey: '',
        authText: this.option1[this.attestation_title_value].text,
        authReason: this.textcon,
        authTitleId: this.option1[this.attestation_title_value].id
      };
      if (!this.textcon) {
        Toast('未填写申请理由');
      } else if (this.textcon.length < 10) {
        Toast('申请理由不少于10个字');
      } else {
        console.log(this.changeFlag);
        if (!this.changeFlag) {
          Dialog.confirm({
            //认证
            title: '确定申请个人认证吗?',
            message: '审核期间不可更改认证信息或取消申请',
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          })
            .then(() => {
              // on confirm
              console.log(applyData);
              get.authApply(qs.stringify(applyData)).then((res) => {
                var data = res.data;
                if (data.code == 0) {
                  Toast('申请成功');
                  _this.getAuthCond();
                } else {
                  if (data.code == 2034) {
                    Dialog.alert({
                      message: '认证特权-专属礼包发放，需要您绑定游戏信息「我的」-「设置」-「绑定游戏信息」',
                    }).then(() => {
                    });
                  } else {
                    this.errorMessage(data);
                  }
                }
              });
            })
            .catch(() => {
              // on cancel
              console.log('取消');
            });
        } else {
          Dialog.confirm({
            //已有认证，更换认证
            title: '确定更换个人认证吗?',
            message: '审核期间不可再次更改认证信息或取消申请',
            confirmButtonText: '申请',
            cancelButtonText: '我再想想'
          })
            .then(() => {
              // on confirm
              if (
                this.condition.authInfo ==
                this.option1[this.attestation_title_value].text
              ) {
                Toast('您已经是' + this.condition.authInfo + '啦');
                _this.getAuthCond();
              } else {
                get.authChange(qs.stringify(applyData)).then((res) => {
                  var data = res.data;
                  if (data.code == 0) {
                    Toast('更换认证申请成功');
                    _this.getAuthCond();
                  } else {
                    this.errorMessage(data);
                  }
                });
              }
            })
            .catch(() => {
              // on cancel
              console.log('取消');
            });
        }
      }
      return;
      this.positionField = 'part3';
      setTimeout(() => {
        this.positionField = 'part4';
      }, 2000);
    },
    toAttestationRuleWrap() {
      this.toAttestationRuleWrapFlag = true;
      this.tohidden = 'on';
    },
    backClick() {
      this.$emit('cancelAttestation');
    },
    closeRule() {
      this.toAttestationRuleWrapFlag = false;
      this.tohidden = '';
    },
    toUpload() {
      return;
      if (this.$store.state.postingFlag) {
        this.$router.push({
          name: 'postPage',
          query: {}
        });
      } else {
        Toast('功能维护中，暂不支持发帖');
      }
    },
    cancelAttestation() {
      let _this = this;
      Dialog.confirm({
        title: '确定取消认证吗?',
        message: '认证取消后，15天内不可再次申请，请谨慎操作',
        confirmButtonText: '确定取消',
        cancelButtonText: '我再想想'
      })
        .then(() => {
          // on confirm
          get.authCancel().then((res) => {
            var data = res.data;
            if (data.code == 0) {
              Toast('取消成功');
              this.positionField = 'part1';
              _this.getAuthCond();
            } else {
              this.errorMessage(data);
            }
          });
        })
        .catch(() => {
          // on cancel
          console.log('取消');
        });
      return;
      this.positionField = 'part1';
    },
    changeAttestation() {
      // let _this = this;
      // Dialog.confirm({
      //   title: '确定更换个人认证吗?',
      //   message: '审核期间不可再次更改认证信息或取消申请',
      //   confirmButtonText:'申请',
      //   cancelButtonText:'我再想想',
      // })
      // .then(() => {
      //   // on confirm
      //   get.authChange().then((res) => {
      //     var data = res.data;
      //     if (data.code == 0) {
      //       Toast("更换成功");
      //       _this.getAuthCond();
      //     } else {
      //       this.errorMessage(data);
      //     }
      //   });
      // })
      // .catch(() => {
      //   // on cancel
      //   console.log('取消');
      // });
      // return;
      this.positionField = 'part1';
      this.changeFlag = true;
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>
